module.exports = __webpack_public_path__ + "media/images/landing_page/mes-1425f07cc994bb7b8e625e861f6f823d.webp";